import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "preact/jsx-runtime";
import { defaultProps } from '@widgets/ResubscribeForm/types/config';
import convertDataAttributes from '@widgets/shared/convertDataAttributes';
import { useCallback, useMemo } from 'preact/compat';
import API from '@widgets/shared/API/connection';
import { useState } from 'react';
import FormNotices from '@widgets/shared/components/FormNotices';
import { Wrapper } from './styles';
function Form(props) {
    const { title, copy, buttonText, email, backgroundImage, } = props;
    const [isRequesting, setIsRequesting] = useState(false);
    const [errorMessage, setErrorMessage] = useState(undefined);
    const [successCopy, setSuccessCopy] = useState(undefined);
    const [complete, setComplete] = useState(false);
    const [successTitle, setSuccessTitle] = useState(undefined);
    const handleSubmit = useCallback((e) => {
        e.preventDefault();
        if (!email) {
            return;
        }
        setIsRequesting(true);
        API.newsletterRegistration(email)
            .then((res) => {
            const { success, errors, message, successCopy: remoteSuccessCopy, successTitle: remoteSuccessTitle, } = res;
            if (success) {
                console.log('Newsletter registration successful: ', res);
                setComplete(true);
                setSuccessTitle(remoteSuccessTitle ?? 'Thank you text here');
                setSuccessCopy(remoteSuccessCopy ?? 'lorem ipsum dolor sit amet consectetur adipiscing elit ut culpa sed congue voluptate mollit vulputate vel anim lobortis at mazim');
            }
            else {
                errors.forEach((error) => {
                    if (error.field) {
                        // @ts-ignore ignoring as error.field is probably email and shouldn't cause issues even if it isn't...
                        setError(error.field, { message: error.message }, { shouldFocus: true });
                    }
                    if (message) {
                        setErrorMessage(message);
                    }
                });
            }
        })
            .finally(() => {
            setIsRequesting(false);
        });
    }, [email]);
    const handleNoticeClose = useCallback(() => {
        setErrorMessage(undefined);
    }, []);
    const canSubmit = useMemo(() => !isRequesting, [isRequesting]);
    const formContent = useMemo(() => {
        if (complete) {
            return (_jsxs(_Fragment, { children: [successTitle && (_jsx("h2", { className: "section__title", children: successTitle })), successCopy && (_jsx("p", { className: "section__copy", children: successCopy }))] }));
        }
        return (_jsxs(_Fragment, { children: [errorMessage && (_jsx("div", { style: { marginBottom: '1rem' }, children: _jsx(FormNotices, { message: errorMessage, type: "error", handleClose: handleNoticeClose, closeTimer: 12000 }) })), _jsx("h2", { className: "section__title", children: title }), _jsx("p", { className: "section__copy", children: copy }), _jsx("button", { type: "submit", disabled: !canSubmit, className: "btn btn--primary btn--wide", children: buttonText })] }));
    }, [successTitle, successCopy, complete, title, copy, canSubmit, handleSubmit, buttonText, errorMessage]);
    if (!email) {
        return null;
    }
    return (_jsx(Wrapper, { children: _jsx("div", { style: { backgroundImage: `url(${backgroundImage})` }, className: "section__content", children: _jsx("form", { method: "post", noValidate: true, onSubmit: handleSubmit, className: "section__form-wrapper", children: formContent }) }) }));
}
function ResubscribeForm(props) {
    const { dataset } = props;
    const config = convertDataAttributes(dataset ?? {});
    const formConfig = useMemo(() => ({
        ...defaultProps,
        ...config,
    }), [config, defaultProps]);
    return (_jsx(Form, { ...formConfig }));
}
export default ResubscribeForm;
